import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Home } from "lucide-react";

export default function NotFound() {
  return (
    <section className="section notfound-section">
      <div className="container text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="notfound-code">
            404
          </h1>
          <h2 className="notfound-title">
            Page Not Found
          </h2>
          <p className="notfound-message">
            The page you are looking for does not exist or has been moved.
          </p>
          <div className="notfound-actions">
            <Link to="/" className="notfound-home-link">
              <Home size={18} />
              Go Home
            </Link>
            <button onClick={() => window.history.back()} className="notfound-back-btn">
              <ArrowLeft size={18} />
              Go Back
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
